import * as React from "preact";
import { render } from "preact";

import App from "./App";

import utils from "../../helpers/utils";

function init(): void {
  const el = document.getElementById("login-app");
  const elMobile = document.getElementById("login-app-mobile");

  // Render app for the desktop version that shows as a dropdown in the top hat
  if (el) {
    const {
      apiUrl,
      inNav,
      hasRole,
      loginLink,
      loginLabel,
      loginToLink,
      loginToLabel,
      loginToTarget,
      changeLoginLink,
      changeLoginLabel,
      multipleLogin,
      disabledPortals,
      forgetLogins,
      forgetLoginsFrom,
      roleRegionEnabled,
      occLoginText,
      occLoginLink,
      occLoginButtonTarget,
      occTarget,
      occModalId,
      occEnabled,
      occTimeout,
    } = el.dataset;
    if (apiUrl) {
      render(
        <App
          apiUrl={apiUrl}
          inNav={utils.isStringTrue(inNav)}
          hasRole={utils.isStringTrue(hasRole)}
          loginLink={loginLink}
          loginLabel={loginLabel}
          loginToLink={loginToLink}
          loginToLabel={loginToLabel}
          loginToTarget={loginToTarget}
          changeLoginLink={changeLoginLink}
          changeLoginLabel={changeLoginLabel}
          multipleLogin={utils.isStringTrue(multipleLogin)}
          disabledPortals={disabledPortals ? JSON.parse(disabledPortals) : null}
          forgetLogins={utils.isStringTrue(forgetLogins)}
          forgetLoginsFrom={forgetLoginsFrom}
          roleRegionEnabled={utils.isStringTrue(roleRegionEnabled)}
          occLoginText={occLoginText}
          occLoginLink={occLoginLink}
          occLoginButtonTarget={occLoginButtonTarget}
          occTarget={occTarget}
          occModalId={occModalId}
          occEnabled={occEnabled}
          occTimeout={occTimeout}
          // Key used to force this entire app to render again as if "new" when re-initialised, rather than keeping old state such as role/region from a previous time this modal was opened
          // More info: https://stackoverflow.com/questions/21749798/how-can-i-reset-a-react-component-including-all-transitively-reachable-state
          // Related bug: https://quilter.atlassian.net/secure/RapidBoard.jspa?rapidView=8&projectKey=PW&modal=detail&selectedIssue=PW-1529
          // key={new Date().getTime()}
        />,
        el
      );
    }
  }
  // Render mobile version that shows in the nav
  if (elMobile) {
    const {
      apiUrl,
      inNav,
      hasRole,
      loginLink,
      loginLabel,
      loginToLink,
      loginToLabel,
      loginToTarget,
      changeLoginLink,
      changeLoginLabel,
      multipleLogin,
      disabledPortals,
      forgetLogins,
      forgetLoginsFrom,
      roleRegionEnabled,
      occLoginText,
      occLoginLink,
      occLoginButtonTarget,
      occTarget,
      occModalId,
      occEnabled,
      occTimeout,
    } = elMobile.dataset;
    if (apiUrl) {
      render(
        <App
          apiUrl={apiUrl}
          inNav={utils.isStringTrue(inNav)}
          hasRole={utils.isStringTrue(hasRole)}
          loginLink={loginLink}
          loginLabel={loginLabel}
          loginToLink={loginToLink}
          loginToLabel={loginToLabel}
          loginToTarget={loginToTarget}
          changeLoginLink={changeLoginLink}
          changeLoginLabel={changeLoginLabel}
          multipleLogin={utils.isStringTrue(multipleLogin)}
          disabledPortals={disabledPortals ? JSON.parse(disabledPortals) : null}
          forgetLogins={utils.isStringTrue(forgetLogins)}
          forgetLoginsFrom={forgetLoginsFrom}
          roleRegionEnabled={utils.isStringTrue(roleRegionEnabled)}
          occLoginText={occLoginText}
          occLoginLink={occLoginLink}
          occLoginButtonTarget={occLoginButtonTarget}
          occTarget={occTarget}
          occModalId={occModalId}
          occEnabled={occEnabled}
          occTimeout={occTimeout}

          // Key used to force this entire app to render again as if "new" when re-initialised, rather than keeping old state such as role/region from a previous time this modal was opened
          // More info: https://stackoverflow.com/questions/21749798/how-can-i-reset-a-react-component-including-all-transitively-reachable-state
          // Related bug: https://quilter.atlassian.net/secure/RapidBoard.jspa?rapidView=8&projectKey=PW&modal=detail&selectedIssue=PW-1529
          // key={new Date().getTime()}
        />,
        elMobile
      );
    }
  }
}
export default { init };
